import {createFragmentContainer, graphql} from 'react-relay';
import React, {Component} from 'react';
import ProjectScoping from '../../containers/new-ui/project/project_scoping';
import {withSocketHandling} from '../../socket/withSocketHandling';
class phasesBetaSplitter extends Component {
	render() {
		const {viewer, router, route, setSocketConfig} = this.props;
		return (
			<div className="section-content project-scoping no-margin">
				{this.props.children}
				<ProjectScoping
					viewer={viewer}
					relay={this.props.relay}
					retry={this.props.retry}
					router={router}
					setSocketConfig={setSocketConfig}
					route={route}
					buyNowTime={this.props.buyNowTime}
				/>
			</div>
		);
	}
}

const phasesBetaSplitterQuery = graphql`
	query phasesBetaSplitter_Query($projectId: String) {
		viewer {
			actualPersonId
			component(name: "project_phases")
			project(id: $projectId) {
				id
			}
			...phasesBetaSplitter_viewer @arguments(projectId: $projectId)
		}
	}
`;

export {phasesBetaSplitterQuery};

export default withSocketHandling(
	createFragmentContainer(phasesBetaSplitter, {
		viewer: graphql`
			fragment phasesBetaSplitter_viewer on Viewer @argumentDefinitions(projectId: {type: "String"}) {
				id
				language
				email
				firstName
				lastName
				timerStartDate
				actualPersonId
				harvestUser
				unit4User
				excludeFromCompanyLockedPeriod
				submitLockedDateYear
				submitLockedDateMonth
				submitLockedDateDay
				availableFeatureFlags {
					key
				}
				timerTask {
					id
				}
				company {
					modules {
						moduleType
					}
					allPersons(first: 1000000, onlyActive: true) @connection(key: "Company_allPersons", filters: []) {
						edges {
							node {
								id
								firstName
								lastName
							}
						}
					}
					id
					currency
					harvestEnabled
					unit4Enabled
					jiraCloudEnabled
					lockedPeriodYear
					lockedPeriodMonth
					lockedPeriodDay
					labels(first: 1000000) {
						edges {
							node {
								id
								name
								color
							}
						}
					}

					roles(first: 1000000) {
						edges {
							...RoleDropdown_roles
							node {
								id
								name
							}
						}
					}
					teams(first: 1000000) {
						edges {
							node {
								id
								name
								teamPersons(first: 1000) {
									edges {
										node {
											id
											person {
												id
											}
										}
									}
								}
							}
						}
					}
				}
				filters(first: 1000000, projectId: $projectId, filterSection: SCOPING)
					@connection(key: "Viewer_filters", filters: []) {
					edges {
						node {
							id
							name
							section
							value
							updatedAt
						}
					}
				}
				projects(first: 1000000) {
					edges {
						node {
							id
							companyProjectId
							name
							status
							isInProjectGroup
							projectColor
						}
					}
				}
				projectGroups(first: 1000) @connection(key: "Viewer_projectGroups", filters: []) {
					edges {
						node {
							id
							companyProjectGroupId
							name
							color
						}
					}
				}
				project(id: $projectId) {
					baselineTargetPrice
					baselineTargetPriceNoExpenses
					baselineTargetMinutes
					id
					name
					budgetWork
					budgetType
					#completion
					sprintTimeBox
					isInProjectGroup
					useBaseline
					projectGroupId
					status
					companyProjectId
					estimationUnit
					timeRegistrations(first: 10000000, onlyProjectRegistrations: true)
						@connection(key: "Project_timeRegistrations", filters: []) {
						edges {
							node {
								id
								minutesRegistered
								invoiced
								price
								updatedAt
								year
								month
								day
								retainerConflictHandled
								task {
									id
								}
								person {
									id
								}
							}
						}
					}
					retainerPeriods(first: 100000) {
						edges {
							node {
								id
								name
								startYear
								startMonth
								startDay
								endYear
								endMonth
								endDay
								available
								periodLength
								periodPeriodicity
								periodPriceAmount
								periodHoursAmount
								periodBudgetType
								periodSettingIgnoreForBilling
								periodSettingSubtractValue
								periodSettingRollValue
								periodSettingAddExpenses
								periodDifferencePriceAmount
								periodDifferenceHoursAmount
								sharedPeriodDifferenceHoursAmount
								sharedPeriodDifferencePriceAmount
								ignoredRolloverHours
								ignoredRolloverPrice
								periodLocked
								periodLockedTime
							}
						}
					}
					minutesPerEstimationPoint
					projectColor
					projectStartYear
					projectStartMonth
					projectStartDay
					projectEndYear
					projectEndMonth
					projectEndDay
					useManualAllocations
					remainingAutoCalculated
					isJiraProject
					useTaskOwner
					useTaskFollowers
					taskLevels
					useManualAllocations
					vstsProject
					vstsAccount
					vstsTwoWaySync
					jiraCloudEpicIds
					jiraSubtaskType
					jiraCloudProject {
						id
					}
					jiraServerProject {
						id
					}
					statusColumnsV2(first: 1000000) {
						edges {
							node {
								id
								name
								order
								jiraStatusId
								category
							}
						}
					}
					rateCard {
						id
						currency
						defaultRate
						rates(first: 10000) {
							edges {
								node {
									id
									rate
									defaultRate
									startDate
									role {
										id
									}
								}
							}
						}
					}
					projectPersons(first: 1000000) {
						edges {
							node {
								id
								role {
									id
									name
								}
								person {
									id
									firstName
									lastName
									initials
									profilePictureId
									profilePictureDefaultId
									permissions
									active
									role {
										id
										name
									}
									client {
										id
									}
								}
							}
						}
					}
					phases(first: 1000000) @connection(key: "Project_phases") {
						edges {
							node {
								baselineTargetPrice
								baselineTargetPriceNoExpenses
								baselineTargetMinutes
								phaseBaselineRoles {
									edges {
										node {
											role {
												id
											}
											baselineMinutes
											baselinePrice
										}
									}
								}
								id
								name
								startYear
								startMonth
								startDay
								deadlineDay
								deadlineMonth
								deadlineYear
								unit4Id
								jiraId
								phasePersons(first: 10000) {
									edges {
										node {
											id
											availableMinutes
											scheduledMinutes
											person {
												id
											}
										}
									}
								}
							}
						}
					}
					sprints(first: 1000000) {
						edges {
							node {
								id
								name
								endYear
								endMonth
								endDay
								startYear
								startMonth
								startDay
							}
						}
					}
					tasks(first: 100000) @connection(key: "Project_tasks", filters: []) {
						edges {
							node {
								id
								userCanDeleteTask
								userCantDeleteTaskReason
								hasInvoicedTime
								hasLockedTime
								hasTimeRegistrations
								approved
								name
								description
								sortOrder
								done
								billable
								blocked
								progress
								bug
								latestUiUpdateAt
								startFrom
								deadlineFrom
								startYear
								startMonth
								startDay
								deadlineDay
								deadlineMonth
								deadlineYear
								estimateLow
								estimateHigh
								estimateForecast
								estimateForecastPrice
								currentPrice
								companyTaskId
								timeLeft
								deadlineFrom
								canStart
								canBeSetToDone
								approved
								highPriority
								hasDependency
								jiraId
								vstsId
								isUnit4Task
								subTaskCount
								favoured
								owner {
									id
									permissions
								}
								followers {
									id
									permissions
								}
								phase {
									id
									name
									startYear
									startMonth
									startDay
									deadlineDay
									deadlineMonth
									deadlineYear
								}
								role {
									id
									name
								}
								sprint {
									id
									name
									startYear
									startMonth
									startDay
									endYear
									endMonth
									endDay
								}
								statusColumnV2 {
									id
									name
									category
								}
								project {
									id
									billable
									estimationUnit
									minutesPerEstimationPoint
									projectEndYear
									projectEndMonth
									projectEndDay
									name
									status
									isJiraProject
									vstsProject
									vstsAccount
									vstsTwoWaySync
									projectColor
									companyProjectId
									harvestProject {
										id
									}
									unit4Project {
										id
										activitiesEnabled
									}
									timelogProject {
										id
									}
								}
								taskLabels {
									id
									label {
										id
										name
										color
									}
								}
								timeRegistrations(first: 10000) @connection(key: "Task_timeRegistrations", filters: []) {
									edges {
										node {
											id
											minutesRegistered
											price
											invoiced
											year
											month
											day
											retainerConflictHandled
											person {
												id
												role {
													id
												}
											}
										}
									}
								}
								assignedPersons {
									id
									firstName
									lastName
									active
									email
									profilePictureId
									profilePictureDefaultId
									permissions
								}
								thisTaskDependsOn(first: 1000) @connection(key: "Task_thisTaskDependsOn") {
									edges {
										node {
											id
											type
											thisDependsOnTask {
												id
												name
												deadlineYear
												deadlineMonth
												deadlineDay
												startYear
												startMonth
												startDay
											}
										}
									}
								}
							}
						}
					}
				}
			}
		`,
	})
);
